import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box,Typography } from "@mui/material";
import LoadStatusPill from "../../Pills/LoadStatusPill/LoadStatusPill";
import TextPill from "../../Pills/TextPill/TextPill";
import ArrowRightAltIcon from "../../../assets/icons/ArrowRightAltIcon";
import theme from "../../../themes/themes";
import { parseISO } from "date-fns";
import { getTimeAgo } from "../../../utils/dateHelpers";
import { useInterval } from "../../../utils/useIntervals";

export default function NotificationsPanelCarrierOffer({ notification }) {
  const [timeAgo, setTimeAgo] = useState(getTimeAgo(parseISO(notification.time), new Date()));

  useInterval(() => {
    setTimeAgo(getTimeAgo(parseISO(notification.time), new Date()));
  }, 60000);

  return (
    <Box sx={{ padding: "4px 0" }}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="label1" color="black.solid.90" sx={{ marginRight: "8px" }}>
          Order: {notification.orderId}
        </Typography>
        <Box sx={{ marginRight: "8px" }}>
          <LoadStatusPill value={notification.orderStatus} darkTheme />
        </Box>
        <Box>
          {notification.actionRequired && !notification.actionCompleted &&
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ width: "1px", height: "9px", backgroundColor: "black_solid.30", marginRight: "8px" }} />
              <TextPill 
                value="Action Required"
                backgroundColor="error.10"
                color="error.80"
                padding="0px 6px"
              />
            </Box>
          }
          {!notification.actionRequired && notification.actionCompleted && 
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ width: "1px", height: "9px", backgroundColor: "black_solid.30", marginRight: "8px" }} />
              <TextPill 
                value="Completed"
                backgroundColor="success.10"
                color="success.80"
                padding="0px 6px"
              />
            </Box>
          }
        </Box>
        <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
          <Typography variant="label1" color="black_solid.70">
            {timeAgo}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", margin: "6px 0"}}>
        <Typography variant="subhead1" color="black_opacity.100">
          {notification.originCity}, {notification.originState}
        </Typography>
        <ArrowRightAltIcon color={theme.palette.black_solid["60"]} sx={{ fontSize: "20px" }}/>
        <Typography variant="subhead1" color="black_opacity.100">
          {notification.destinationCity}, {notification.destinationState}
        </Typography>
      </Box>
      <Typography variant="body1" color="black_solid.70">
        {notification.message}
      </Typography>
    </Box>
  );
}

NotificationsPanelCarrierOffer.propTypes = {
  notification: PropTypes.object.isRequired
};